let useNativeConsole = true;
let relayErrors = false;
let useDatadog = false;
const isClientSide = () => typeof window !== "undefined";
const hasDatadog = () => typeof window.DD_RUM !== "undefined";
const canUseDatadogRelay = (flag, checker) => flag && checker();
const initLogger = (config = {
  useNativeConsole: true,
  relayErrors: false,
  useDatadog: false
}, _isClientSide = isClientSide, _hasDatadog = hasDatadog) => {
  if (_isClientSide()) {
    if (!config.useNativeConsole && !_hasDatadog()) {
      console.warn("agent relay not found on window");
    }
    useNativeConsole = config.useNativeConsole;
    useDatadog = canUseDatadogRelay(config.useDatadog, _hasDatadog);
    relayErrors = config.relayErrors;
  }
  return {
    useNativeConsole,
    relayErrors,
    useDatadog
  };
};
const datadogRelay = {
  async log(type, log) {
    var _a, _b;
    const attr = typeof log === "object" ? log : { value: log };
    (_b = (_a = window.DD_RUM) == null ? void 0 : _a.addAction) == null ? void 0 : _b.call(_a, `LOG:${type}`, attr);
  },
  async warn(type, warn) {
    var _a, _b;
    const attr = typeof warn === "object" ? warn : { value: warn };
    (_b = (_a = window.DD_RUM) == null ? void 0 : _a.addAction) == null ? void 0 : _b.call(_a, `WARN:${type}`, attr);
  },
  async error(type, err, _relayErrors = relayErrors) {
    var _a, _b, _c, _d;
    let attr;
    if (typeof err === "object" && err.message) {
      attr = { value: err.message };
    } else {
      attr = typeof err === "object" && !(err instanceof Error) ? err : { value: err };
    }
    (_b = (_a = window.DD_RUM) == null ? void 0 : _a.addAction) == null ? void 0 : _b.call(_a, `ERR:${type}`, attr);
    if (err instanceof Error && _relayErrors) (_d = (_c = window.DD_RUM) == null ? void 0 : _c.addError) == null ? void 0 : _d.call(_c, err, { internalName: `ERR:${type}` });
  }
};
const prettyPrint = (name, data, color = "#1a73e8") => {
  let attr;
  if (typeof data === "object" && data.message) {
    attr = { value: data.message };
  } else {
    attr = typeof data === "object" ? data : { value: data };
  }
  console.group(`%c${name}`, `color: ${color}; font-weight: bold; background-color: white; padding: 2px;`);
  Object.keys(attr).forEach((key) => {
    console.log(`%c${key}: ${attr[key]}`, `color: ${color}; font-weight: bold; background-color: white; padding: 2px;`);
  });
  if (data instanceof Error) console.error(data);
  console.groupEnd();
};
const logger = {
  /**
   * Handle logging requests
   * Sends log message to console or other services
   * @param name {String} name or category of event to be recorded
   * @param [value] {String | Object} value to be passed to logging utility
   * If a string is passed, it will be registered as a custom attribute with a key of 'value'
   * If an object is possed, it will be recorded as key:value pairs for querying later.
   */
  log(name, value, pp = prettyPrint, uc = useNativeConsole) {
    uc ? pp(`logger.log "${name}"`, value, "#339900") : datadogRelay.log(name, value);
  },
  /**
   * Handle warn log requests
   * Sends log message to console or other services
   * @param name {String} name or category of event to be recorded
   * @param [value] {String | Object} value to be passed to logging utility
   * If a string is passed, it will be registered as a custom attribute with a key of 'value'
   * If an object is possed, it will be recorded as key:value pairs for querying later.
   */
  warn(name, value, pp = prettyPrint, uc = useNativeConsole) {
    uc ? pp(`logger.warn "${name}"`, value, "#FF8033") : datadogRelay.warn(name, value);
  },
  /**
   * Handle error log requests
   * Sends log message to console or other services
   * @param name {String} name or category of event to be recorded
   * @param [err] {Error | String | Object} value to be passed to logging utility.
   * If an error is passed, it will be logged in product to the JS errors console.
   * If a string is passed, it will be registered as a custom attribute with a key of 'value'
   * If an object is possed, it will be recorded as key:value pairs for querying later.
   */
  error(name, err, pp = prettyPrint, uc = useNativeConsole) {
    uc ? pp(`logger.error "${name}"`, err, "#cc3300") : datadogRelay.error(name, err);
  }
};
export {
  canUseDatadogRelay,
  datadogRelay,
  hasDatadog,
  initLogger,
  logger,
  prettyPrint
};
//# sourceMappingURL=logger.mjs.map
